
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/shared/components/ui/Button';
import { ArrowLeft } from 'lucide-react';
import { ModuleGuide } from '@/shared/components/ui/ModuleGuide';

export function ClientProspectDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-6">
      <ModuleGuide title="Client/Prospect Details" summary="View detailed information." steps={['Review details', 'Update status']} />
      
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={() => navigate(-1)} className="p-2">
          <ArrowLeft className="w-5 h-5 text-on-surface-variant" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-on-surface">Details for Record #{id}</h1>
          <p className="text-on-surface-variant text-sm mt-1">This is a placeholder for the detailed view.</p>
        </div>
      </div>

      <div className="bg-card rounded-lg border border-border p-12 text-center text-on-surface-variant">
        Detailed view component under construction.
      </div>
    </div>
  );
}
